import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import GlobalContext from 'contexts/globalContext';
import TagManager from 'react-gtm-module';
import Routes from './components/Base/Routes';
import './App.css';

function App() {
  const tagManagerArgs = {
    gtmId: 'GTM-KH8T2GF',
  };

  TagManager.initialize(tagManagerArgs);

  return (
    <GlobalContext>
      <div className="App">
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </div>
    </GlobalContext>
  );
}

export default App;
